import { useState } from "react";
import { useGlobalContext } from "../GlobalContext";

export default function useVolunteerLogin() {
  const [loading, setLoading] = useState(false);

  const {
    api,
    setIsUnauthorised,
    setAdminId,
    setAccessToken,
    setAdmin,
  } = useGlobalContext();

  const login = async ({ mobile, password, step, otp }) => {
    setLoading(true);

    try {
      const payload = {
        mobile: String(mobile || ""),
        password: String(password || ""),
        step: String(step || ""),
        ipAddress: "",
        otp: Number(step) === 2 ? String(otp || "") : "",
        latitude: "",
        longitude: "",
        deviceId: "",
        userType: "Distributor",
      };

      const response = await api.post(
        "/api/Volunteer/v1.0/volunteerLogin",
        payload
      );

      if (response?.data?.responseCode === "00") {
        const userData = response?.data?.response;

        if (Number(step) === 1) {
          return {
            success: true,
            nextStep: 2,
            message: response?.data?.responseMessage,
          };
        }

        if (Number(step) === 2) {
          sessionStorage.setItem("volunteerData", JSON.stringify(userData));
          sessionStorage.setItem("volunteerToken", userData?.accessToken || "");

          sessionStorage.removeItem("admin");

          setAdmin?.(null);
          setAdminId?.(userData?.userId || null);
          setAccessToken?.(userData?.accessToken || null);

          return {
            success: true,
            completed: true,
            data: userData,
            message: response?.data?.responseMessage,
          };
        }
      }

      if (response?.data?.responseCode === "401") {
        setIsUnauthorised(true);

        return {
          success: false,
          message: response?.data?.responseMessage || "Unauthorised",
        };
      }

      return {
        success: false,
        message: response?.data?.responseMessage || "Login failed",
      };
    } catch (error) {
      console.error("volunteerLogin error:", error);

      return {
        success: false,
        message:
          error?.response?.data?.responseMessage ||
          "Login failed. Please try again.",
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    login,
    loading,
  };
}